import React from "react";
import ReportListItem from "../../../../components/reports-list-item";
import getReportsStore from "../../../../stores/reports-store";
import { TReport } from "../../../../Types";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";

const ReportsPartition = withLiteObserverAndTheme<{
  data: TReport[];
  total: number;
}>((props) => {
  const { data, total } = props;
  const status = getReportsStore().status.get().value;

  return (
    <React.Fragment>
      {data.map((report, index) => {
        return (
          <ReportListItem
            key={report.reportId}
            pageName={"REPORTS"}
            report={report}
            status={status}
            takenActionType={""}
            eventID={0}
            date={report.reportedOn}
            reportNumberFromPartition={index + 1}
            reportsPartitionMaxNumber={total}
          />
        );
      })}
    </React.Fragment>
  );
});

export default ReportsPartition;
